import(/* webpackMode: "eager" */ "/var/www/mindbalance-web/node_modules/react-loading-skeleton/dist/index.js");
import(/* webpackMode: "eager" */ "/var/www/mindbalance-web/src/app/(home)/components/Home.jsx")